import React from "react";
import { STATIC_IMG } from "../../../../const";
import "./styles.css";

// Define props interface for CustomNodeContent component
interface CustomNodeContentProps {
  data: {
    smallPhoto:string
    Name:string
    Title:string
    Email:string
  }
}

const CustomNodeContent: React.FC<CustomNodeContentProps> = (props) => {
  return (
    <>
      <div className="node-container">
        <div className="node-details">
          <div className="node-content">
            <img
              className="node-img"
              src={
                props.data.smallPhoto ??
                STATIC_IMG
              }
              alt="Profile"
            />
            <div className="node-info">
              <div className="node-name">{props.data.Name}</div>
              <div className="node-role">{props.data.Title}</div>
            </div>
          </div>

          <div className="node-right-text">
            <span>{props.data.Email}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomNodeContent;
